import { Grid, TextField } from "@mui/material";

import { FixedMidpointRoundingToDown } from "utils/helpers/numbers";
import { TRADE_AMOUNT_TYPE } from "pages/BasicTrade/components/constants";
import { useFormContext } from "react-hook-form";
import { useMemo } from "react";

function TradeTotal({ srcDecimalCount, destDecimalCount }) {
  const { watch } = useFormContext();

  const amount = watch("amount");
  const price = watch("price");
  const amountTypeId = watch("amountTypeId");

  const total = useMemo(() => {
    if (amountTypeId === TRADE_AMOUNT_TYPE.amount.id) {
      const tempVal = amount * price || 0;

      return FixedMidpointRoundingToDown(tempVal, destDecimalCount);
    } else {
      const tempVal = amount / price || 0;

      return FixedMidpointRoundingToDown(tempVal, srcDecimalCount);
    }
  }, [amount, amountTypeId, price, destDecimalCount, srcDecimalCount]);

  return (
    <Grid container my={1}>
      <Grid item xs={12}>
        <TextField
          inputProps={{
            readonly: true,
          }}
          placeholder="قیمت نهایی"
          value={total}
          sx={{ textAlign: "center" }}
        />
      </Grid>
    </Grid>
  );
}

export default TradeTotal;
